module.exports = __webpack_public_path__ + "static/media/molecular_gen_1.ffa368f2.jpeg";